<template>
    <section class="row company-view" v-if="this.carregado">
        <div class="col-12">
			<div class="row tit_page">
				<div class="col-12">

					<div class="float-md-left">
						<h1>Histórico de investimento <span>id#{{this.id}}</span></h1>
					</div>

					<!-- EXIBE APENAS NO CELULAR -->
					<div class="mob">
						<span class="float-left">id#{{this.id}}</span>
						<div class="back float-right">
							<!-- <router-link to="/investimentos/historico" title="Voltar"><i>&nbsp;</i> voltar</router-link> -->
							<a @click="$router.go(-1)" href="javascript:;" title="Voltar"><i>&nbsp;</i> voltar</a>
						</div>
					</div>

					<div class="back back-hide float-md-right">
						<!-- <router-link to="/investimentos/historico" title="Voltar"><i>&nbsp;</i> voltar</router-link> -->
						<a @click="$router.go(-1)" href="javascript:;" title="Voltar"><i>&nbsp;</i> voltar</a>
					</div>
					<div class="clearfix"></div>
				</div> 
			</div>

            <hr class="divider">

            <div :class="'row rating-'+lowerCase(this.ReservaInvestimento.SolicitacaoId.Score)">
                <div class="col-12">
					<div class="tit">
						<div class="float-md-left">
							<h2>{{this.ReservaInvestimento.SolicitacaoId.Empresa.RazaoSocial}}
								{{this.ReservaInvestimento.SolicitacaoId.Impacto != null ?this.ReservaInvestimento.SolicitacaoId.Impacto.NomeEmpresa:""}}
								{{this.ReservaInvestimento.SolicitacaoId.Ccb != null ?this.ReservaInvestimento.SolicitacaoId.Ccb.RazaoSocial:""}}

							</h2>
							<span>CNPJ: {{formatarCnpj(this.ReservaInvestimento.SolicitacaoId.Documento)}}</span>
							<small>{{formatarTipoEmprestimo(this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo)}}</small>							
						</div>
						<div class="rating  float-md-right" v-if="this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto'">
							<strong>Score da operação <span class="circle score"></span> {{this.ReservaInvestimento.SolicitacaoId.Score}}</strong>
						</div>
						<div class="clearfix"></div>
					</div>
                </div>
            </div>

            <div class="row">
                <section class="col-12 col-md-7 col-lg-8">

                    <div :class="'row rating-'+lowerCase(this.ReservaInvestimento.SolicitacaoId.Score)">
                        <div class="col-12 col-md-6 col-lg-4">
                            <div class="box">
                                <label>Valor investido</label>
                                <p>R$ {{formatCurrency(this.ReservaInvestimento.Valor)}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4" v-if="this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto' && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social'">
                            <div class="box">
                                <label>Retorno Bruto Anual</label>
                                <p>{{formatCurrency(this.ReservaInvestimento.SolicitacaoId.RetornoBrutoAnual)}}% a.a.</p>                                    
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4" v-if="this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto' && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social'">
                            <div class="box">
                                <label>Retorno Bruto Mensal</label>
                                <p>{{formatCurrency(this.ReservaInvestimento.SolicitacaoId.RetornoBrutoMensal)}}% a.m.</p>                                   
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4" v-if="this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto' && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social'">
                            <div class="box">
                                <label>Retorno Estimado do CDI</label>
								<p>{{formatInt(this.ReservaInvestimento.SolicitacaoId.Cdi)}}%</p>                                   
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4">
                            <div class="box">
                                <label>Prazo previsto</label>
                                <p>{{this.ReservaInvestimento.SolicitacaoId.Prazo}} meses</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4">
                            <div class="box">
                                <label>Data do investimento</label>
                                <p>{{formatData(this.ReservaInvestimento.Created)}}</p>
                            </div>
                        </div>
                    </div>

                    <div class="entry">
                        <h4>Captação de recursos</h4>

                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="box">
									<label>Início</label>
									<p>{{formatData(this.ReservaInvestimento.SolicitacaoId.InicioCaptacao)}}</p>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="box">
									<label>Total de investidores</label>
									<p>{{this.ReservaInvestimento.SolicitacaoId.QuantidadeReservasInvestimento}}</p>                                    
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="box">
 									<label>Valor total captado</label>
									<p>R$ {{formatCurrency(this.ReservaInvestimento.SolicitacaoId.ValorCaptado)}}</p>                                   
                                </div>
                            </div>
                        </div>                        
                    </div>

                    <div class="entry">
                        <h4>Dados do empréstimo</h4>

                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="box">
									<label>Valor solicitado</label>
									<p>R$ {{formatCurrency(this.ReservaInvestimento.SolicitacaoId.Valor)}}</p>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="box">
									<label>Duração</label>
									<p>{{this.ReservaInvestimento.SolicitacaoId.Prazo}} meses</p>                                    
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="box">
 									<label>Valor total do empréstimo</label>
									<p>R$ {{this.ReservaInvestimento.SolicitacaoId.ValorParcela == 0?formatCurrency(this.ReservaInvestimento.SolicitacaoId.Valor): formatCurrency(this.ReservaInvestimento.SolicitacaoId.ValorParcela *  this.ReservaInvestimento.SolicitacaoId.Prazo)}} </p>                                   
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="box">
 									<label>Valor da parcela</label>
									<p>R$ {{this.ReservaInvestimento.SolicitacaoId.ValorParcela == 0? formatCurrency(this.ReservaInvestimento.SolicitacaoId.Valor/this.ReservaInvestimento.SolicitacaoId.Prazo) : formatCurrency(this.ReservaInvestimento.SolicitacaoId.ValorParcela)}}</p>                                   
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="box">
									<label>Juros</label>
									<p>{{formatCurrency(this.ReservaInvestimento.SolicitacaoId.TaxaJuros)}}% a.m.</p>
									
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4" style="display:none;" v-if="this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto' && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social'">
                                <div class="box">
									<label>Taxa total efetiva</label>
									<p>3,13% a.m.-</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="entry">
                        <h4>Dados da empresa</h4>
						<div class="row">
							<div class="col-12 col-lg-6">
								<label>Empresa <span>(Razão social)</span></label>
								<span>
									{{this.ReservaInvestimento.SolicitacaoId.Empresa.RazaoSocial}}
									{{this.ReservaInvestimento.SolicitacaoId.Impacto != null ?this.ReservaInvestimento.SolicitacaoId.Impacto.NomeEmpresa:""}}
									{{this.ReservaInvestimento.SolicitacaoId.Ccb != null ?this.ReservaInvestimento.SolicitacaoId.Ccb.RazaoSocial:""}}


								</span>
							</div>
							<div class="col-12 col-lg-3">
								<label>CPF/CNPJ</label>
								<span>{{formatarCnpj(this.ReservaInvestimento.SolicitacaoId.Documento)}}</span>
							</div>
							<div class="col-12 col-lg-3">
								<label>Nome do responsável</label>
								<span>{{this.ReservaInvestimento.SolicitacaoId.Nome}}</span>
							</div>
							<div class="col-12 col-lg-6" v-if="this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto' && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social'">
								<label>Nome fantasia</label>
									<span>
									{{this.ReservaInvestimento.SolicitacaoId.Empresa.NomeFantasia}}
									{{this.ReservaInvestimento.SolicitacaoId.Ccb != null ?this.ReservaInvestimento.SolicitacaoId.Ccb.NomeFantasia:""}}

								</span>
							</div>
							<div class="col-12 col-lg-6" v-if="this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto'  && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social'">
								<label>Telefone comercial</label>
								<span>{{this.ReservaInvestimento.SolicitacaoId.TelefoneComercial}}</span>
							</div>	
							<div class="col-12 col-lg-3" v-if="this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto'  && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social'">
								<label>Data de fundação</label>
								<span>{{formatData(this.ReservaInvestimento.SolicitacaoId.Empresa.DataFundacao)}}</span>
							</div>	
							<div class="col-12 col-lg-3" v-if="this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto' && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social'">
								<label>Número de funcionários</label>
								<span>{{this.ReservaInvestimento.SolicitacaoId.Empresa.QuantidadeEmpregados}} empregados</span>
							</div>
							<div class="col-12 col-lg-6" v-if="this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto' && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social'">
								<label>Nome do grupo ecônomico</label>
								<span>{{this.ReservaInvestimento.SolicitacaoId.Empresa.NomeGrupoEconomico == ""?"Não pertence a nenhum grupo econômico":this.ReservaInvestimento.SolicitacaoId.Empresa.NomeGrupoEconomico}}</span>
							</div>	
							<div class="col-12">
								<label>Endereço</label>
								<span v-if="this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo== 'emprestimo-coletivo' ">
									{{this.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Cidade != "" ?(this.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Logradouro + ' , ' + this.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Numero + ' - ' +this.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Complemento + ' , ' + this.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Bairro + ' - ' + this.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Cep + ' - ' + this.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Cidade + ' / '+ this.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Uf): ""}}
								</span>
									
								<span v-if="this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo== 'emprestimo-de-impacto'  || this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo == 'emprestimo-social' ">	
									{{this.ReservaInvestimento.SolicitacaoId.Impacto != null && this.ReservaInvestimento.SolicitacaoId.Impacto.TituloCampanha != ""  ?(this.ReservaInvestimento.SolicitacaoId.Impacto.Cidade + ' / '+ this.ReservaInvestimento.SolicitacaoId.Impacto.UF): ""}}
								</span>
								<span v-if="this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo== 'emprestimo-ccb' ">
									{{this.ReservaInvestimento.SolicitacaoId.Ccb != null && this.ReservaInvestimento.SolicitacaoId.Ccb.RazaoSocial != ""  ?(this.ReservaInvestimento.SolicitacaoId.Ccb.Logradouro + ' , ' + this.ReservaInvestimento.SolicitacaoId.Ccb.Numero + '-' +this.ReservaInvestimento.SolicitacaoId.Ccb.Complemento + ' , ' + this.ReservaInvestimento.SolicitacaoId.Ccb.Bairro + ' - ' + this.ReservaInvestimento.SolicitacaoId.Ccb.Cep + ' - ' + this.ReservaInvestimento.SolicitacaoId.Ccb.Cidade + ' / '+ this.ReservaInvestimento.SolicitacaoId.Ccb.Uf): ""}}
								</span>
							</div>
							<div class="col-12 col-lg-5" v-if="this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto' && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social'">
								<label>Site</label>
								<span><a target="_blank" :href="this.ReservaInvestimento.SolicitacaoId.Empresa.Site" >{{this.ReservaInvestimento.SolicitacaoId.Empresa.Site}}</a></span>
							</div>
							<div class="col-12 col-lg-7" v-if="this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto' && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social'">
								<label>Redes Sociais</label>
								<span>
									<a v-if="companyFacebook" :href="companyFacebook" class="fab fa-facebook-square"></a>
									<a v-if="companyTwitter" :href="companyTwitter" class="fab fa-twitter"></a>
									<a v-if="companyLinkedin" :href="companyLinkedin" class="fab fa-linkedin-in"></a>
									<a v-if="companyInstagram" :href="companyInstagram" class="fab fa-instagram"></a>
									<a v-if="companyVimeo" :href="companyVimeo" class="fab fa-vimeo-v"></a>
								</span>
							</div>
						</div>
                    </div>

                    <div class="entry">
                        <h5>Descrição breve sobre a empresa</h5>
						<p v-if="this.ReservaInvestimento.SolicitacaoId.Impacto != null" v-html="this.ReservaInvestimento.SolicitacaoId.Impacto.InformacaoResumida"></p>
						<p v-if="this.ReservaInvestimento.SolicitacaoId.Empresa != null" v-html="this.ReservaInvestimento.SolicitacaoId.Empresa.InformacaoInstitucional"></p>
						<p v-if="this.ReservaInvestimento.SolicitacaoId.Ccb != null" v-html="this.ReservaInvestimento.SolicitacaoId.Ccb.DescricaoEmpresa"></p>
                    </div>

                    <div class="entry" v-if="this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo == 'emprestimo-de-impacto'  || this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo == 'emprestimo-social'">
                        <h5>Sobre a empresa</h5>
						<p v-if="this.ReservaInvestimento.SolicitacaoId.Impacto != null" v-html="this.ReservaInvestimento.SolicitacaoId.Impacto.InformacaoInstitucional"></p>
                    </div>

					 <div class="entry" v-if="this.ReservaInvestimento.UrlEndosso || this.ReservaInvestimento.UrlCCB || this.ReservaInvestimento.SolicitacaoId.CCBsAssinaturas == true ">
                        <h5>Documentos</h5>
						<div class="row">
							<div class="col-12 col-lg-6" v-if="this.ReservaInvestimento.UrlEndosso">
								<a :href="this.ReservaInvestimento.UrlEndosso" class="docs" target="_blank">
									Endosso
								</a>
							</div>
							 <div class="col-12 col-lg-6" style="padding-top:5px" v-if="this.ReservaInvestimento.UrlCCB  || this.ReservaInvestimento.SolicitacaoId.CCBsAssinaturas == true">
								 <a v-if="this.ReservaInvestimento.UrlCCB" :href="this.ReservaInvestimento.UrlCCB" class="docs" target="_blank">
									CCB
								</a>
								<a target="_blank" v-if="this.ReservaInvestimento.SolicitacaoId.CCBsAssinaturas == true" :href='ccbUrl+"/imprimirccb.aspx?code="+this.ReservaInvestimento.CodigoBMP+"&copias=1"' class="docs">
									CCBs
								</a>
							 </div>
						</div>
						
                    </div>
                </section> 

				<!-- TABELA DE BOLETOS -->
				<aside class="col-12 col-md-5 col-lg-4">
					<div class="box">
						<div class="tit">
							<div class="float-left">
								<h4>Pagamentos</h4>
							</div>
							<div class="legenda float-left float-md-right">
								<div class="title-lg status qt">
									<span class="sts sm"></span>
									<label>Quitado</label>
								</div>
								<div class="title-lg status vc">
									<span class="sts sm"></span>
									<label>Vencido</label>
								</div>
								<div class="title-lg status av">
									<span class="sts sm"></span>
									<label>A vencer</label>
								</div>
							</div>
                            <div class="clearfix"></div>
						</div>
						<div class="table-responsive">
							<table class="table">
								<thead>
									<tr>
										<th scope="col" width="40" class="align-middle">Parc.</th>
										<th scope="col" class="align-middle">Valor</th>
										<th scope="col" class="align-middle">Venc.</th>
										<th scope="col" class="align-middle">Status</th>
									</tr>
								</thead>
								<tbody v-if="this.ReservaInvestimento.SolicitacaoId.GerouBoletosPagamento">
										<tr v-for="(fatura, index) in this.faturas" :key="index">
											<td class="align-middle">
												{{fatura.IndiceFatura + 1}}
											</td>
											<td class="align-middle">
												R$ {{formatCurrency(fatura.valorParcela)}}
											</td>
											<td class="align-middle">
												{{formatDate(fatura.Boleto.due_date)}}
											</td> 
											<td class="status align-middle text-center" :class="getFaturaStatusClass(fatura)">
												<span class="sts md"></span>
											</td>
										</tr>
								</tbody>

								<tbody v-if="!this.ReservaInvestimento.SolicitacaoId.GerouBoletosPagamento">
										<tr v-for="n in this.ReservaInvestimento.SolicitacaoId.Prazo" :key="n" >
										<td class="align-middle">{{n}}</td>
										<td class="align-middle">R$  {{formatCurrency(valorParcela)}}</td>                                  
										<td class="align-middle">-</td>
										<td class="status av align-middle"><span class="sts md"></span></td>
										<!-- qt - Quitado | av - A vencer | vc - Vencido  -->
									</tr>
								</tbody>
									
							</table>
						</div>
					</div>
				</aside>               
            </div>
        </div> 
    </section>
</template>


<script>
/* eslint-disable */
import ApiClientGO from '../utils/api-client-go'
import ApiClient from '../utils/api-client'
import * as mutationTypes from '@/store/mutation-types.js'
import Masker from '@/utils/masker'
import Calculos from '../mixins/Calculos';

export default {
	mixins: [Calculos],
	components: {  },
	data() {
		return {
			ccbUrl:process.env.CCB_URL,
			carregado:false,
			ReservaInvestimento: {
				SolicitacaoId:{}
			},
			reservaInvId: {},
			valorParcela:0,
			faturas: null,
		}
	},
	
	computed: {
		id: function() {return this.ajustIdOportunidade(this.ReservaInvestimento.SolicitacaoId.IdOportunidade,5)},
		CalcularValor: function()
		{
			return this.ReservaInvestimento.SolicitacaoId.ValorParcela == 0 ? this.formatCurrency(this.ReservaInvestimento.SolicitacaoId.Valor/this.ReservaInvestimento.SolicitacaoId.Prazo) : this.formatCurrency(this.ReservaInvestimento.SolicitacaoId.ValorParcela);
		},
		companyFacebook() { return this.ReservaInvestimento.SolicitacaoId.Empresa.Facebook },
		companyTwitter() { return this.ReservaInvestimento.SolicitacaoId.Empresa.Twitter },
		companyLinkedin() { return this.ReservaInvestimento.SolicitacaoId.Empresa.Linkedin },
		companyInstagram() { return this.ReservaInvestimento.SolicitacaoId.Empresa.Instagram },
		companyVimeo() { return this.ReservaInvestimento.SolicitacaoId.Empresa.Vimeo },
	},
	methods: {
		formatarTipoEmprestimo(tipoEmprestimo) {
			if (tipoEmprestimo == "emprestimo-ccb") {
				return "Empréstimo CCB"
			}
			if (tipoEmprestimo == "emprestimo-coletivo") {
				return "Empréstimo Coletivo"
			}

			if( tipoEmprestimo == "emprestimo-de-impacto" || tipoEmprestimo == "emprestimo-de-impacto2") {
				return "Empréstimo de Impacto"
			}

			if (tipoEmprestimo == "veiculo-em-garantia") {
				return "Empréstimo com Garantia Veicular"
			}

			if (tipoEmprestimo == "imovel-em-garantia") {
				return "Empréstimo com Garantia Imobiliária"
			}
			
			if (tipoEmprestimo == "antecipacao-recebiveis") {
				return "Antecipação de Recebíveis"
			}

			return tipoEmprestimo;
		},
		ajustIdOportunidade(id, qtd) {
			var s = String(id);
			while (s.length < (qtd || 2)) {
				s = "0" + s;
			}
			return s;
		},
		formatCurrency(value) {
			if(value == null || value == undefined)
			{
				return parseFloat(0).toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2})		
			}

			return value.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2})
		},
		formatInt(value) {
			if(value == null || value == undefined)
			{
				return parseInt(0).toLocaleString('pt-BR', {minimumFractionDigits: "0", maximumFractionDigits: 0})		
			}
			return value.toLocaleString('pt-BR', {minimumFractionDigits: "0", maximumFractionDigits: 0})
		},
		formatarCnpj(cnpj) {
			return Masker.maskCnpj(cnpj)
		},
		getFaturaStatusClass(boleto) {
			let cls;
			let stringDate = boleto.Boleto.due_date;
			let spliter    = stringDate.split("-");
			let boletoDate = new Date(spliter[0], spliter[1] - 1, spliter[2], 23, 59, 59);
			let today      = new Date();
			let status     = boleto.StatusBoleto;

			if(boletoDate < today && status !== "paid") {
				// Vencido
				cls = "vc";
			} else if(status === "" || status === undefined)  {
				// Sem status
				cls = "ds";
			} else if(status === "pending") {
				// A vencer
				cls = "av";
			} else if (status === "paid"){
				// Quitado
				cls = "qt";
			}

			return cls;
		},
		formatDate(date) {
			let dateArray = date.split('-')
			let day = dateArray[2]
			let month = dateArray[1]
			let year = dateArray[0]

			return day + "/" + month + "/" + year;
		},
		lowerCase(texto) {
			if (texto == null || texto == undefined || texto == "") return "a";

			if (texto == "AA" || texto == "HR") return texto.toLowerCase();

			return texto.substr(0,1).toLowerCase();
		},
		formatData(data){
			var date = new Date(data);
			return date.toLocaleDateString('pt-BR');
		},
		//tagueamento GA
		taggingGA() {
			this.$ga.page({
				page: '/historico/historico-de-investimento/:id',
				title: 'HistoricoInvestimento',
			})
		},
	},
	async created() {
		this.reservaInvId = this.$route.params.id

		if(window.location.href.indexOf("dashboard-app") != -1)
	
		this.$store.commit(mutationTypes.START_LOADING)
		ApiClient.getReservaSolicitacao(this.$route.params.id)
			.then(loanRequest => {
				this.ReservaInvestimento = loanRequest
				this.carregado = true;
					if(this.ReservaInvestimento.SolicitacaoId.RetornoBrutoMensal  == undefined){
						this.ReservaInvestimento.SolicitacaoId.RetornoBrutoMensal = 0;
					}
				return ''
			})
			.then(() => ApiClient.getFaturas(this.ReservaInvestimento.SolicitacaoId._id))
			.then(faturas => {
				let valorParcela
				if(this.ReservaInvestimento.SolicitacaoId.Alongamento){
					return ApiClientGO.tabelaValoresInvestidores(this.ReservaInvestimento.SolicitacaoId._id, this.ReservaInvestimento._id)
						.then((resp)=>{
							for (let i = 0; i < faturas.length; i++) {
								faturas[i] = {...faturas[i], valorParcela:resp.data.tabela.TabelaPrice[i].Parcela.toFixed(2)}
							}
							this.faturas = faturas;
							this.$store.commit(mutationTypes.STOP_LOADING)
							return ''
						})
						.catch((e) =>{
							console.log(e)
							this.$store.commit(mutationTypes.STOP_LOADING) 
						})
				}else{
					valorParcela = this.PMT(this.ReservaInvestimento.Valor, this.ReservaInvestimento.SolicitacaoId.RetornoBrutoMensal/100, this.ReservaInvestimento.SolicitacaoId.Prazo)
					for (let i = 0; i < faturas.length; i++) {
						faturas[i] = {...faturas[i], valorParcela}
					}
					this.faturas = faturas;
					this.$store.commit(mutationTypes.STOP_LOADING)
					return ''	
				}
			})
			.catch(() =>{
				this.$store.commit(mutationTypes.STOP_LOADING) 
			})
			
		//tagueamento GA
		await this.taggingGA();
	},
}
</script>



<style lang="scss" scoped>
	@import "../assets/styles/iouu/variables";
    @import "../assets/styles/iouu/mixins";
        
    .company-view {
        .tit {
            margin-bottom: 30px;
        }

		a {
			&.docs {
				font-size: calcRem(25);
				color: #8B8B8B;
				display: inline-block;
				font-weight: 700;
				width: 100%;
				text-align: center;
				@include gradient-linear(#fff,
				#e8e8e8);
				border: 1px solid #DDDDDD;
				padding: calcRem(32) 0;
				margin-bottom: 1rem;

				@include sm {
					margin: 1rem 0;
					padding: 1rem 0;
				}

				@include xs {
					margin: 1rem 0;
					padding: 1rem 0;
				}
			}
		}

        @include xs {
            h1 {
                @include font-size(22px);
                display: block;

                span {
                    @include font-size(14px); 
                    background-size: 5px;
                }
			}
			
            .tit {
                margin-bottom: 20px!important;
                h2 {
                    @include font-size(28px);
                }
                span {
                    @include font-size(17px);
                }
			}
            .box {
                padding: 15px;
                margin-bottom: 20px;
                p {
                    @include font-size(18px);
                    font-weight: bold;
                }
            }
		}
		
		@include sm {
            h1 {
                @include font-size(22px);
                display: block;

                span {
                    @include font-size(14px); 
                    background-size: 5px;
                }
			}
		}
    }

    aside {
        .box {
            // MEDIA max: 1199px
            @include brkp-01(1199px) {
                margin-top: 1rem;
            }
            
            .tit {
                margin-bottom: 0px!important;
                padding-bottom: 15px;

                h4 {
                    @include font-size(18px);
                }
            }

            .legenda {
				.status {
					float: left;
					padding-left: 10px;
				}
				label,
				span {
					display: inline-block;
				}
                @include xs {
					margin-top: 10px;
					.status {
						float: left;
						padding-left: 0px;
						padding-right: 10px;
					}
                }
			}
			
            .table {
				margin:0px;
                td,
                th {
					text-align: center;

                    // MEDIA  max: 1305px
                    @include brkp-01(1300px) {
                        font-size: calcRem(12) !important;
                    }
                    // MEDIA max: 1305px
                    &:last-child {
                        @include brkp-01(1305px) {
                            //display: none;	
                        }
                    }
                    &:nth-child(2) {
                        @include xs {
                            width: 80px;
                        }
                    }
				}
				
				th {
					@include font-size(13px);
				}
				td {
					@include font-size(14px);
				}
				thead{
					th {
						border-top: none;
					}
				}
				tbody {
					tr {
						border-bottom: none;
					}
				}

                @include xs {
					margin: 0px;

                    th, td {
                        text-align: center;
                    }

                    thead {
                        th {
                            border-top: none;
                        }
                    }

                    tbody {
                        tr {
                            &:last-child {
                                border-bottom: none;
                            }
                        }
                    }
                }
            }
        }
	}
	
	.tit_page {
		@include xs {
			h1 span {
				display: none;
			}
			.back-hide {
				display: none;
			}
		}

		@include sm {
			h1 span {
				display: none;
			}
			.back-hide {
				display: none;
			}
		}

		@include md {
			.mob {
				display: none;
			}
		}

		@include lg {
			.mob {
				display: none;
			}
		}

		@include xl {
			.mob {
				display: none;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/HistoricProfile.vue